export function Timezone__IsSameAsLocal(timezone: string) {
  const localTimezone =
    Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone ?? timezone;
  return timezone === localTimezone;
}
